/** Subtle ambient gold dust floating over the table */
export default function GoldDustOverlay() {
  const specks = Array.from({ length: 18 }, (_, i) => ({
    id: i,
    left: (i * 17 + 7) % 94,
    top: (i * 23 + 11) % 88,
    delay: (i * 0.7) % 4,
    duration: 4 + (i % 3),
    size: 2 + (i % 2),
  }));

  return (
    <div className="pointer-events-none absolute inset-0 z-[2] overflow-hidden" aria-hidden>
      {specks.map((s) => (
        <span
          key={s.id}
          className="tp-gold-dust absolute rounded-full"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
          }}
        />
      ))}
    </div>
  );
}
